import { CREATE_GEN_AI_ROOM_REQUEST,CREATE_GEN_AI_ROOM_SUCCESS, CREATE_GEN_AI_ROOM_FAILURE, CREATE_GEN_AI_ROOM_RESET} from "../../actions/dsr-gen-ai-actions-types";


// Original
const INITIAL_STATE_CREATE_GEN_AI_ROOM = { results: '' }

export function dsrCreateGenAiReducer(state = INITIAL_STATE_CREATE_GEN_AI_ROOM, action) {
    switch (action.type) {
        case CREATE_GEN_AI_ROOM_REQUEST:
			return { ...state, isLoading: true, results: {} };
		case CREATE_GEN_AI_ROOM_SUCCESS:
			return { ...state, isLoading: false, results: action.payload };
		case CREATE_GEN_AI_ROOM_FAILURE:
			return { ...state, isLoading: false, error: 'Error while trying to create gen ai room' };
        case CREATE_GEN_AI_ROOM_RESET:
            return INITIAL_STATE_CREATE_GEN_AI_ROOM
        default:
            return state;
    }
}